import * as React from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  progressBar: {
    display: "flex",
    gap: "5px",
  },
  step: {
    flex: 1,
    height: "8px",
    borderRadius: "5px",
    background: "linear-gradient(to right, #567ccd 50%, #ccc 50%)",
    backgroundSize: "200% 100%",
    backgroundPosition: "right bottom",
    transition: "background-position 0.6s ease-out",
  },
  stepDone: {
    backgroundPosition: "left bottom",
  },
});

const ProgressStripe = ({ steps, progress }) => {
  const styles = useStyles();
  return (
    <div className={styles.progressBar}>
      {Array.from({ length: steps || 0 }, (_, i) => (
        <div key={i} className={mergeClasses(styles.step, i < progress && styles.stepDone)}></div>
      ))}
    </div>
  );
};

ProgressStripe.propTypes = {
  steps: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
};

export default ProgressStripe;
